/* tslint:disable */
/* eslint-disable */
/**
 * grpc/v1/search_service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { RpcStatus } from '../models'
// @ts-ignore
import { V1GlobalSearchResponse } from '../models'
// @ts-ignore
import { V1RunBackfillRequest } from '../models'
// @ts-ignore
import { V1RunBackfillResponse } from '../models'
/**
 * SearchServiceApi - axios parameter creator
 * @export
 */
export const SearchServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary GlobalSearch — подсказки топбара: сгруппированная по типам выдача с ранжированием.
     * @param {string} [query] query — поисковый запрос (FTS, префиксный).
     * @param {Array<SearchServiceGlobalSearchTypesEnum>} [types] types — фильтр по типам сущностей; пусто &#x3D; все.   - SEARCH_ENTITY_TYPE_AGENT: DEV-475 (ТЗ §8.1): агенты и компании-партнёры в глобальном поиске + автоподсказки названий компаний (матчинг через нормализацию/транслитерацию индексируемого текста).
     * @param {number} [limitPerType] limit_per_type — лимит результатов на тип (0 &#x3D; серверный дефолт, напр. 5; максимум ограничивается сервером).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchServiceGlobalSearch: async (
      query?: string,
      types?: Array<SearchServiceGlobalSearchTypesEnum>,
      limitPerType?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/search`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (query !== undefined) {
        localVarQueryParameter['query'] = query
      }

      if (types) {
        localVarQueryParameter['types'] = types
      }

      if (limitPerType !== undefined) {
        localVarQueryParameter['limitPerType'] = limitPerType
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary RunBackfill — разовая переиндексация существующих данных (ТОЛЬКО admin/HOS). Тянет всех клиентов/сделки/ЖК из сервисов-источников под токеном вызвавшего админа (обход RBAC-фильтра по менеджеру) и идемпотентно наполняет индекс. Выполняется асинхронно: отвечает сразу, прогресс — в логах сервиса.
     * @param {V1RunBackfillRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchServiceRunBackfill: async (
      body: V1RunBackfillRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('searchServiceRunBackfill', 'body', body)
      const localVarPath = `/api/v1/search/backfill`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * SearchServiceApi - functional programming interface
 * @export
 */
export const SearchServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SearchServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary GlobalSearch — подсказки топбара: сгруппированная по типам выдача с ранжированием.
     * @param {string} [query] query — поисковый запрос (FTS, префиксный).
     * @param {Array<SearchServiceGlobalSearchTypesEnum>} [types] types — фильтр по типам сущностей; пусто &#x3D; все.   - SEARCH_ENTITY_TYPE_AGENT: DEV-475 (ТЗ §8.1): агенты и компании-партнёры в глобальном поиске + автоподсказки названий компаний (матчинг через нормализацию/транслитерацию индексируемого текста).
     * @param {number} [limitPerType] limit_per_type — лимит результатов на тип (0 &#x3D; серверный дефолт, напр. 5; максимум ограничивается сервером).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchServiceGlobalSearch(
      query?: string,
      types?: Array<SearchServiceGlobalSearchTypesEnum>,
      limitPerType?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GlobalSearchResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchServiceGlobalSearch(
        query,
        types,
        limitPerType,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SearchServiceApi.searchServiceGlobalSearch']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary RunBackfill — разовая переиндексация существующих данных (ТОЛЬКО admin/HOS). Тянет всех клиентов/сделки/ЖК из сервисов-источников под токеном вызвавшего админа (обход RBAC-фильтра по менеджеру) и идемпотентно наполняет индекс. Выполняется асинхронно: отвечает сразу, прогресс — в логах сервиса.
     * @param {V1RunBackfillRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchServiceRunBackfill(
      body: V1RunBackfillRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RunBackfillResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchServiceRunBackfill(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SearchServiceApi.searchServiceRunBackfill']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * SearchServiceApi - factory interface
 * @export
 */
export const SearchServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = SearchServiceApiFp(configuration)
  return {
    /**
     *
     * @summary GlobalSearch — подсказки топбара: сгруппированная по типам выдача с ранжированием.
     * @param {string} [query] query — поисковый запрос (FTS, префиксный).
     * @param {Array<SearchServiceGlobalSearchTypesEnum>} [types] types — фильтр по типам сущностей; пусто &#x3D; все.   - SEARCH_ENTITY_TYPE_AGENT: DEV-475 (ТЗ §8.1): агенты и компании-партнёры в глобальном поиске + автоподсказки названий компаний (матчинг через нормализацию/транслитерацию индексируемого текста).
     * @param {number} [limitPerType] limit_per_type — лимит результатов на тип (0 &#x3D; серверный дефолт, напр. 5; максимум ограничивается сервером).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchServiceGlobalSearch(
      query?: string,
      types?: Array<SearchServiceGlobalSearchTypesEnum>,
      limitPerType?: number,
      options?: any,
    ): AxiosPromise<V1GlobalSearchResponse> {
      return localVarFp
        .searchServiceGlobalSearch(query, types, limitPerType, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary RunBackfill — разовая переиндексация существующих данных (ТОЛЬКО admin/HOS). Тянет всех клиентов/сделки/ЖК из сервисов-источников под токеном вызвавшего админа (обход RBAC-фильтра по менеджеру) и идемпотентно наполняет индекс. Выполняется асинхронно: отвечает сразу, прогресс — в логах сервиса.
     * @param {V1RunBackfillRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchServiceRunBackfill(
      body: V1RunBackfillRequest,
      options?: any,
    ): AxiosPromise<V1RunBackfillResponse> {
      return localVarFp
        .searchServiceRunBackfill(body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * SearchServiceApi - object-oriented interface
 * @export
 * @class SearchServiceApi
 * @extends {BaseAPI}
 */
export class SearchServiceApi extends BaseAPI {
  /**
   *
   * @summary GlobalSearch — подсказки топбара: сгруппированная по типам выдача с ранжированием.
   * @param {string} [query] query — поисковый запрос (FTS, префиксный).
   * @param {Array<SearchServiceGlobalSearchTypesEnum>} [types] types — фильтр по типам сущностей; пусто &#x3D; все.   - SEARCH_ENTITY_TYPE_AGENT: DEV-475 (ТЗ §8.1): агенты и компании-партнёры в глобальном поиске + автоподсказки названий компаний (матчинг через нормализацию/транслитерацию индексируемого текста).
   * @param {number} [limitPerType] limit_per_type — лимит результатов на тип (0 &#x3D; серверный дефолт, напр. 5; максимум ограничивается сервером).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchServiceApi
   */
  public searchServiceGlobalSearch(
    query?: string,
    types?: Array<SearchServiceGlobalSearchTypesEnum>,
    limitPerType?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return SearchServiceApiFp(this.configuration)
      .searchServiceGlobalSearch(query, types, limitPerType, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary RunBackfill — разовая переиндексация существующих данных (ТОЛЬКО admin/HOS). Тянет всех клиентов/сделки/ЖК из сервисов-источников под токеном вызвавшего админа (обход RBAC-фильтра по менеджеру) и идемпотентно наполняет индекс. Выполняется асинхронно: отвечает сразу, прогресс — в логах сервиса.
   * @param {V1RunBackfillRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchServiceApi
   */
  public searchServiceRunBackfill(body: V1RunBackfillRequest, options?: RawAxiosRequestConfig) {
    return SearchServiceApiFp(this.configuration)
      .searchServiceRunBackfill(body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * @export
 */
export const SearchServiceGlobalSearchTypesEnum = {
  Invalid: 'SEARCH_ENTITY_TYPE_INVALID',
  Client: 'SEARCH_ENTITY_TYPE_CLIENT',
  Deal: 'SEARCH_ENTITY_TYPE_DEAL',
  Property: 'SEARCH_ENTITY_TYPE_PROPERTY',
  Agent: 'SEARCH_ENTITY_TYPE_AGENT',
  PartnerCompany: 'SEARCH_ENTITY_TYPE_PARTNER_COMPANY',
} as const
export type SearchServiceGlobalSearchTypesEnum =
  (typeof SearchServiceGlobalSearchTypesEnum)[keyof typeof SearchServiceGlobalSearchTypesEnum]
